import React from 'react';
import { Button } from 'reactstrap';

/**
 * Estado de erro da Lista Geral, no mesmo formato do estado vazio da tabela.
 * Existe para o usuário saber que a busca falhou e poder tentar de novo
 * (incidente de 28/09/2026, precatorios_web#9).
 *
 * Uso: <ListLoadError message={loadError} onRetry={() => reload(endpoint)} />
 */
const ListLoadError = ({ message, onRetry, colSpan = 9 }) => (
    <tbody>
        <tr>
            <td colSpan={colSpan} className="text-center py-5">
                <i className="ni ni-fat-remove display-4 text-danger mb-3" />
                <p className="text-muted">{message}</p>
                <Button color="primary" size="sm" onClick={onRetry}>
                    Tentar novamente
                </Button>
            </td>
        </tr>
    </tbody>
);

export default ListLoadError;
